import { computed, ref } from '@vue/composition-api'
import { cloneDeep, isEmpty } from 'lodash-es'
import store from '@/store'
import { setStore, getStore } from '@/util/store'
export default function () {
  const menuList = computed(() => store.state.user.menu)
  const menus = computed(() => {
    const list = cloneDeep(menuList.value)
    list.forEach((item) => {
      item.children &&
        item.children.forEach((obj) => {
          if (obj.children) {
            obj.children = obj.children.filter((ch) => !ch.isHide)
          }
        })
      if (item.children) {
        item.children = item.children.filter((obj) => !isEmpty(obj.children))
      }
    })
    return list
  })
  const keyWords = ref('')
  const activeIndex = ref(0)
  const setKeyWords = (v) => {
    keyWords.value = v
  }
  const setActiveIndex = (index) => {
    activeIndex.value = index
    setKeyWords('')
  }

  const resultList = computed(() => {
    const searchText = keyWords.value
    const men = cloneDeep(menus.value.filter((item) => item.permission !== 'common_menu'))
    if (!searchText) {
      return []
    }

    if (!Array.isArray(men)) {
      return []
    }
    const filterList = []
    men.forEach((item) => {
      if (!isEmpty(item.children)) {
        filterList.push(...item.children)
      }
    })
    const searchList = filterList.filter((item) => {
      const { name, children } = item
      const hasParent = name.includes(searchText)
      if (hasParent) {
        item.name = name.replace(searchText, `<span class="color-active">${searchText}</span>`)
        return true
      }
      if (isEmpty(children)) {
        return false
      }
      const hasChildren = children.filter((c) => c.name.includes(searchText))
      if (hasChildren.length > 0) {
        item.children = hasChildren.map((c) => ({
          ...c,
          label: c.name,
          name: c.name.replace(searchText, `<span class="color-active">${searchText}</span>`)
        }))
        return true
      }
      return false
    })
    return searchList
  })
  const getCommonMenu = (item) => {
    const commonMenu = getStore({ name: 'commonMenu' }) || []
    if (isEmpty(commonMenu)) {
      setStore({ name: 'commonMenu', content: [item] })
      return
    }
    const index = commonMenu.findIndex((obj) => obj.id === item.id)
    if (index !== -1) {
      commonMenu[index].clickCount += 1
    } else {
      commonMenu.push({
        ...item,
        clickCount: 1
      })
    }
    commonMenu.sort((a, b) => {
      // 如果a没有clickCount属性，则排在后面
      if (!a.clickCount) return 1
      // 如果b没有clickCount属性，则排在后面
      if (!b.clickCount) return -1
      // 根据clickCount属性进行比较
      return b.clickCount - a.clickCount
    })
    const topMenu = commonMenu.slice(0, 6)
    const menu = menuList.value.filter((item) => item.permission !== 'common_menu')
    const parentList = cloneDeep([].concat(...menu.map((obj) => obj.children)))

    parentList.forEach((item) => {
      item.children = []
      topMenu.forEach((obj) => {
        if (obj.parentId === item.id) {
          item.children.push(obj)
        }
      })
    })
    const children = parentList.filter((item) => item.children.length)
    setStore({ name: 'commonMenu', content: commonMenu })
    const list = menuList.value
    list[0].children = children
    store.commit('SET_MENU', list)
  }
  return {
    setActiveIndex,
    activeIndex,
    menus,
    keyWords,
    setKeyWords,
    resultList,
    getCommonMenu
  }
}
